import { cn } from '@/lib/utils';
import React from 'react';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';

export interface PillTabItem {
    value: string;
    label: string;
}

const PILL_TAB_TRIGGER_CLASSNAME =
    'relative shrink-0 whitespace-nowrap px-4 sm:px-6 py-1.5 border border-transparent data-[state=active]:bg-transparent data-[state=active]:shadow-none rounded-md font-medium text-muted-foreground data-[state=active]:text-foreground hover:text-foreground transition-all duration-200';

interface PillTabsListProps {
    tabs: PillTabItem[];
    className?: string;
    /** Stretch to the container width with equal-width tabs, so it lines up with the controls below. */
    fullWidth?: boolean;
    /** Lightweight navigation tabs: no filled container, an underline marks the active tab. */
    underline?: boolean;
}

const UNDERLINE_TRIGGER_CLASSNAME =
    'relative -mb-px shrink-0 whitespace-nowrap px-4 py-2.5 border-b-2 border-transparent data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:shadow-none rounded-none font-medium text-muted-foreground data-[state=active]:text-foreground hover:text-foreground transition-colors duration-200';

export const PillTabsList: React.FC<PillTabsListProps> = ({
    tabs,
    className,
    fullWidth = false,
    underline = false
}) =>
    underline ? (
        <TabsList
            className={cn(
                'flex justify-start items-center bg-transparent p-0 border-b border-border rounded-none w-full h-auto overflow-x-auto scrollbar-hidden',
                className
            )}
        >
            {tabs.map((tab) => (
                <TabsTrigger
                    key={tab.value}
                    value={tab.value}
                    className={UNDERLINE_TRIGGER_CLASSNAME}
                >
                    {tab.label}
                </TabsTrigger>
            ))}
        </TabsList>
    ) : (
    <TabsList
        indicatorClassName="bg-background dark:bg-white/10 shadow-xs border border-border rounded-md"
        className={cn(
            'flex justify-start items-center bg-muted dark:bg-white/5 p-1 border border-border rounded-xl max-w-full h-auto overflow-x-auto scrollbar-hidden',
            fullWidth ? 'w-full' : 'w-fit',
            className
        )}
    >
        {tabs.map((tab) => (
            <TabsTrigger
                key={tab.value}
                value={tab.value}
                className={cn(
                    PILL_TAB_TRIGGER_CLASSNAME,
                    fullWidth && 'flex-1'
                )}
            >
                {tab.label}
            </TabsTrigger>
        ))}
    </TabsList>
    );
